/**
 * Asset configuration for all game assets
 * Defines all image and audio assets that need to be preloaded
 */

export interface ImageAssetConfig {
  id: string;
  src: string;
  category: 'backdrop' | 'background' | 'character' | 'cutscene' | 'ui' | 'item';
  preload?: boolean;
}

export interface AudioAssetConfig {
  id: string;
  src: string;
  category: 'music' | 'sfx' | 'voice' | 'ambient';
  loop?: boolean;
  volume?: number;
  preload?: boolean;
}

/**
 * All image assets in the game
 */
export const imageAssets: ImageAssetConfig[] = [
  // NPC assets
  {
    id: 'sparkle',
    src: 'assets/npc/invis2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sparkle',
    src: 'assets/npc/sparkle.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes',
    src: 'assets/npc/karakter_tes.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes1',
    src: 'assets/npc/karakter_tes1.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes1',
    src: 'assets/npc/item_dust.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes2',
    src: 'assets/npc/karakter_tes2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_pancingan',
    src: 'assets/sprite/sprite_pancingan.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_ato',
    src: 'assets/sprite/sprite_ato.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_ato_holga',
    src: 'assets/sprite/sprite_ato_holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_stake',
    src: 'assets/sprite/sprite_stake.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_bunga',
    src: 'assets/sprite/sprite_bunga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_darius',
    src: 'assets/sprite/sprite_darius.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_diana',
    src: 'assets/sprite/sprite_diana.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_elsa',
    src: 'assets/sprite/sprite_elsa.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_stake_elsa',
    src: 'assets/sprite/sprite_stake_elsa.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_holga',
    src: 'assets/sprite/sprite_holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_nenek1',
    src: 'assets/sprite/sprite_nenek1.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_nenek2',
    src: 'assets/sprite/sprite_nenek2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_lady',
    src: 'assets/sprite/sprite_npc_lady.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_mom',
    src: 'assets/sprite/sprite_npc_mom.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_nenek',
    src: 'assets/sprite/sprite_npc_nenek.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_sondakh',
    src: 'assets/sprite/sprite_sondakh.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_sondakh_dead',
    src: 'assets/sprite/sprite_sondakh_dead.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_gate_close',
    src: 'assets/sprite/gate_close.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_gate_open',
    src: 'assets/sprite/gate_open.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'ato_up',
    src: 'assets/sprite/ato_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_up',
    src: 'assets/sprite/elsa_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob2_up',
    src: 'assets/sprite/mob2_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'nenek2_up',
    src: 'assets/sprite/nenek2_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sondakh_up',
    src: 'assets/sprite/sondakh_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_up',
    src: 'assets/sprite/bunga_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'holga_up',
    src: 'assets/sprite/holga_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob3_up',
    src: 'assets/sprite/mob3_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd',
    src: 'assets/sprite/npc_crowd.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd_animated',
    src: 'assets/sprite/crowd_animated.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'small_sparkle',
    src: 'assets/sprite/small_sparkle.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitter',
    src: 'assets/sprite/glitter.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitterV2',
    src: 'assets/sprite/glitter_v2.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitter_small',
    src: 'assets/sprite/glitter_small.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd_animated_flipped',
    src: 'assets/sprite/crowd_animated_flipped.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_up',
    src: 'assets/sprite/diana_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob1_up',
    src: 'assets/sprite/mob1_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'nenek1_up',
    src: 'assets/sprite/nenek1_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'romo_up',
    src: 'assets/sprite/romo_up.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'clickable_indicator',
    src: 'assets/sprite/clickable_indicator.png',
    category: 'character',
    preload: true,
  },

  // Background assets
  {
    id: 'background_map',
    src: 'assets/background/map.jpg',
    category: 'background',
    preload: true,
  },

  // Backdrop assets
  {
    id: 'backdrop_danau',
    src: 'assets/backdrop/danau.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_kamar_yan',
    src: 'assets/backdrop/kamar_yan.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'interior_bar',
    src: 'assets/backdrop/interior_bar.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'portal',
    src: 'assets/backdrop/portal.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_gereja',
    src: 'assets/backdrop/gereja.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_hutan',
    src: 'assets/backdrop/hutan.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_interior_rumah',
    src: 'assets/backdrop/interior_rumah.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_sofa',
    src: 'assets/backdrop/ruang_tamu_sofa.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_meja_makan_zoomed',
    src: 'assets/backdrop/ruang_tamu_meja_makan_zoomed.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_kalender',
    src: 'assets/backdrop/ruang_tamu_kalender.png',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'backdrop_stake_empty',
    src: 'assets/backdrop/stake_empty.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_elsa',
    src: 'assets/backdrop/stake_elsa.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'elsa_sleep',
    src: 'assets/backdrop/elsa_sleep.jpg',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'backdrop_stake_on_fire',
    src: 'assets/backdrop/stake_on_fire.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_on_fire_2',
    src: 'assets/backdrop/stake_on_fire_2.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_with_person',
    src: 'assets/backdrop/stake_with_person.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_zoomed',
    src: 'assets/backdrop/ruang_tamu_zoomed.png',
    category: 'backdrop',
    preload: true,
  },


  {
    id: 'backdrop_rumah',
    src: 'assets/backdrop/rumah.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/desa.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/kamar_diana.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/kamar_nenek.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/kamar_nenek_fill.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/kamar_nenek_zoom.png',
    category: 'backdrop',
    preload: true,
  },
  // Character assets (original size)
  {
    id: 'ato',
    src: 'assets/character/v2/ato.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'ato_a',
    src: 'assets/character/v2/ato_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl',
    src: 'assets/character/v2/little_girl_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl_h',
    src: 'assets/character/v2/little_girl_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl_n',
    src: 'assets/character/v2/little_girl.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga',
    src: 'assets/character/v2/bunga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_a',
    src: 'assets/character/v2/bunga_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_h',
    src: 'assets/character/v2/bunga_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'darius',
    src: 'assets/character/v2/darius.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana',
    src: 'assets/character/v2/diana.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'diana_h',
    src: 'assets/character/v2/diana_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_p',
    src: 'assets/character/v2/diana_p.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_s',
    src: 'assets/character/v2/diana_s.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'elsa',
    src: 'assets/character/v2/elsa.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'elsa_h',
    src: 'assets/character/v2/elsa_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_a',
    src: 'assets/character/v2/elsa_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_p',
    src: 'assets/character/v2/elsa_p.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_s',
    src: 'assets/character/v2/elsa_s.png',
    category: 'character',
    preload: true,
  },


  {
    id: 'holga',
    src: 'assets/character/v2/holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'nenek',
    src: 'assets/character/v2/nenek.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sondakh',
    src: 'assets/character/v2/sondakh.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'yanf',
    src: 'assets/character/v2/yanf.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'yanm',
    src: 'assets/character/v2/yanm.png',
    category: 'character',
    preload: true,
  },
  // Cutscene assets
  {
    id: 'cutscene_d1_crowd',
    src: 'assets/cutscene/D1_crowd.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_ato_bogem',
    src: 'assets/cutscene/ato_bogem.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'custcene_ato_pull',
    src: 'assets/cutscene/ato_pull.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_diana_pray',
    src: 'assets/cutscene/diana_pray.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_grave_empty',
    src: 'assets/backdrop/grave_empty.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_sleep_bunga',
    src: 'assets/backdrop/sleep_bunga.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_sleep_elsa',
    src: 'assets/backdrop/sleep_elsa.jpg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_d2_win',
    src: 'assets/cutscene/D2_WIN.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_win_2',
    src: 'assets/cutscene/D2_WIN_2.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack',
    src: 'assets/cutscene/D2_songko_attack.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_covered',
    src: 'assets/cutscene/D2_songko_attack_covered.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_covered_blood',
    src: 'assets/cutscene/D2_songko_attack_covered_blood.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl',
    src: 'assets/cutscene/D2_songko_attack_girl.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl_1',
    src: 'assets/cutscene/D2_songko_attack_girl_1.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl_2',
    src: 'assets/cutscene/D2_songko_attack_girl_2.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_splatter',
    src: 'assets/cutscene/D2_songko_attack_splatter.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_block',
    src: 'assets/cutscene/D2_songko_block.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_danau_bh',
    src: 'assets/cutscene/DANAU_BH.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_spoiler_image',
    src: 'assets/cutscene/SPOILER_image.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_black',
    src: 'assets/cutscene/black.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy',
    src: 'assets/cutscene/death_boy.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2',
    src: 'assets/cutscene/death_boy_v2.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2_dor',
    src: 'assets/cutscene/death_boy_v2_dor.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2_floor',
    src: 'assets/cutscene/death_boy_v2_floor.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_1',
    src: 'assets/cutscene/death_crowd_1.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_2',
    src: 'assets/cutscene/death_crowd_2.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_3',
    src: 'assets/cutscene/death_crowd_3.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_4',
    src: 'assets/cutscene/death_crowd_4.png',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_sondakh_death',
    src: 'assets/cutscene/death_sondakh.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_sondakh_death_kalung',
    src: 'assets/cutscene/death_sondakh_kalung.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_sondakh_death',
    src: 'assets/cutscene/death_diana_blood_zoom.png',
    category: 'cutscene',
    preload: true,
  },

  {
    id: 'cutscene_sondakh_death',
    src: 'assets/cutscene/death_diana_blood_zoom.png',
    category: 'cutscene',
    preload: true,
  },

  {
    id: 'secret_1',
    src: 'assets/cutscene/secret_1.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_2',
    src: 'assets/cutscene/secret_2.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_3',
    src: 'assets/cutscene/secret_3.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_4',
    src: 'assets/cutscene/secret_4.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_5',
    src: 'assets/cutscene/secret_5.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_6',
    src: 'assets/cutscene/secret_6.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_7',
    src: 'assets/cutscene/secret_7.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_8',
    src: 'assets/cutscene/secret_8.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_9',
    src: 'assets/cutscene/secret_9.jpg',
    category: 'cutscene',
    preload: true,
  },

  {
    id: 'secret_b1',
    src: 'assets/cutscene/secret_b1.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b2',
    src: 'assets/cutscene/secret_b2.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b3',
    src: 'assets/cutscene/secret_b3.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b4',
    src: 'assets/cutscene/secret_b4.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b5',
    src: 'assets/cutscene/secret_b5.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b6',
    src: 'assets/cutscene/secret_b6.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b7',
    src: 'assets/cutscene/secret_b7.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b8',
    src: 'assets/cutscene/secret_b8.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b9',
    src: 'assets/cutscene/secret_b9.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'secret_b10',
    src: 'assets/cutscene/secret_b10.jpg',
    category: 'cutscene',
    preload: true,
  },



  // Items assets
  {
    id: 'item_boneka',
    src: 'assets/items/item_boneka.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'item_drink',
    src: 'assets/items/item_drink2.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'item_panada',
    src: 'assets/items/item_panada.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'item_uang',
    src: 'assets/items/item_uang.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_bible',
    src: 'assets/items/item_bible.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_ikan',
    src: 'assets/items/item_ikan.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_liontin',
    src: 'assets/items/item_liontin.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_sendal',
    src: 'assets/items/item_sendal.png',
    category: 'item',
    preload: true,
  },
];

/**
 * All audio assets (imported from SoundConfig)
 */
export const audioAssets: AudioAssetConfig[] = [
  // Music
  {
    id: 'music_musicBox',
    src: 'assets/audio/bgm/bg-music-box.mp3',
    category: 'music',
    loop: true,
    volume: 0.5,
    preload: true,
  },
  {
    id: 'music_piano',
    src: 'assets/audio/bgm/bg-piano.mp3',
    category: 'music',
    loop: true,
    volume: 0.1,
    preload: true,
  },

  // Sound Effects
  {
    id: 'sfx_chicken',
    src: 'assets/audio/sfx/chicken.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_bladePierce',
    src: 'assets/audio/sfx/blade-pierce.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_click',
    src: 'assets/audio/sfx/click.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_doorKnock',
    src: 'assets/audio/sfx/door-knock.mp3',
    category: 'sfx',
    volume: 1,
    preload: true,
  },
  {
    id: 'sfx_burn',
    src: 'assets/audio/sfx/burn.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_doorSlam',
    src: 'assets/audio/sfx/door-slam.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_openDoor',
    src: 'assets/audio/sfx/open-door.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_girlScream',
    src: 'assets/audio/sfx/girl-scream.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_knifeStab',
    src: 'assets/audio/sfx/knife-stab.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_monsterLaugh',
    src: 'assets/audio/sfx/monster-laugh.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_monsterScream',
    src: 'assets/audio/sfx/monster-scream.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_orchestraFreak',
    src: 'assets/audio/sfx/orhcestra-freak.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_swordSeathe',
    src: 'assets/audio/sfx/sword-seathe.mp3',
    category: 'sfx',
    volume: 0.5,
    preload: true,
  },
  {
    id: 'sfx_womanScream',
    src: 'assets/audio/sfx/woman-scream.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_heart',
    src: 'assets/audio/sfx/heart-beat.mp3',
    category: 'sfx',
    volume: 2,
    preload: true,
  },
];

/**
 * Get all assets that should be preloaded
 */
export function getPreloadAssets(): { images: ImageAssetConfig[], audio: AudioAssetConfig[] } {
  return {
    images: imageAssets.filter(asset => asset.preload !== false),
    audio: audioAssets.filter(asset => asset.preload !== false),
  };
}

/**
 * Get asset by ID
 */
export function getImageAsset(id: string): ImageAssetConfig | undefined {
  return imageAssets.find(asset => asset.id === id);
}

export function getAudioAsset(id: string): AudioAssetConfig | undefined {
  return audioAssets.find(asset => asset.id === id);
}

/**
 * Get assets by category
 */
export function getImageAssetsByCategory(category: ImageAssetConfig['category']): ImageAssetConfig[] {
  return imageAssets.filter(asset => asset.category === category);
}

export function getAudioAssetsByCategory(category: AudioAssetConfig['category']): AudioAssetConfig[] {
  return audioAssets.filter(asset => asset.category === category);
}
